import LinearProgress, { LinearProgressProps } from '@material-ui/core/LinearProgress';
import { Box, Typography } from '@material-ui/core';

export default function ProgressBar(props: LinearProgressProps & { value: number }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }} style={props.style}>
      <Box sx={{ width: '100%', mr: 1, display: 'flex', justifyContent: 'center' }}>
        <LinearProgress variant='determinate' {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant='body2' color={props?.style?.color || 'text.secondary'}>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
